import Insight from "../insightClass";
import React from "react";
import { insight116Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight116 = new Insight(
  "08 June 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight116Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-06-08)",
  "",
  `A joint venture between JERA Nex BP and EnBW has submitted Section 36 consent applications for the Morven offshore wind farm to the Scottish government. The project, located around 60 kilometres off the coast of Aberdeenshire at its closest point, is planned as two separate schemes, Morven North and Morven South, with a combined installed capacity of up to 3 GW and around 190 turbines.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-06-08)</h1>
    <h2></h2>
    <p className="article-date">08 June 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. Scotland’s 3 GW Morven project moves into consent stage</h3>
    <p>
      A joint venture between JERA Nex BP and EnBW has submitted Section 36
      consent applications for the Morven offshore wind farm to the Scottish
      government. The project, located around 60 kilometres off the coast of
      Aberdeenshire at its closest point, is planned as two separate schemes,
      Morven North and Morven South, with a combined installed capacity of up to
      3 GW and around 190 turbines.
    </p>
    <p>
      This is one of the most important UK development milestones of the week
      because it shows that ScotWind projects are gradually moving from leasing
      and early-stage development into formal consenting. The developer secured
      seabed rights in the 2022 ScotWind leasing round and has spent three years
      progressing environmental and technical work since its EIA Scoping Report
      in 2023.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Morven matters not only because of its size, but because it sits at the
      intersection of UK energy security, Scottish industrial policy and
      developer portfolio discipline. After earlier changes to the JERA Nex
      BP–EnBW UK portfolio, including the discontinuation of Morgan and
      ownership changes around Mona, the continued progress of Morven suggests
      that developers are becoming more selective rather than withdrawing from
      the UK market altogether.
    </p>
    <p>
      For Scotland, the key question will be how much of Morven’s value chain
      can translate into domestic port, fabrication, grid and operations
      activity. Consent submission is a major step, but grid timing, supply
      chain cost, auction eligibility and route-to-market clarity will
      ultimately determine whether the project remains commercially deliverable.
    </p>
    <h3>2. Inch Cape completes all monopile installation in Scotland</h3>
    <p>
      All 54 monopile foundations have been installed at the 1.1 GW Inch Cape
      offshore wind farm in Scotland. The project is jointly owned by ESB and
      Red Rock Renewables and will use 72 Vestas V236-15.0 MW turbines,
      installed on a mix of 54 monopile foundations and 18 jacket foundations
      supported by 54 pin piles.
    </p>
    <p>
      Construction activity will continue this year, including transition
      pieces, jacket foundations, remaining export cable sections, inter-array
      cables and first turbine installation. The project is expected to produce
      first power in late 2026 and enter full commercial operation in 2027.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Inch Cape is a strong signal that, despite macro pressure on offshore wind
      economics, UK construction execution is still progressing on major
      projects. Foundation completion is a meaningful de-risking milestone
      because it moves the project beyond one of the most capital-intensive
      offshore installation phases.
    </p>
    <p>
      The hybrid foundation strategy also reflects the more complex site
      conditions now typical of large-scale UK projects. From a market
      perspective, Inch Cape strengthens Scotland’s near-term offshore wind
      delivery profile before the larger ScotWind pipeline arrives. For
      suppliers, the message is clear: the UK remains one of the few markets
      with both gigawatt-scale construction activity today and a deep future
      pipeline, but project bankability depends increasingly on disciplined
      execution and predictable delivery windows.
    </p>
    <h3>
      3. Ireland’s Arklow Bank Wind Park 2 updates environmental submission
    </h3>
    <p>
      SSE has updated plans for the 800 MW Arklow Bank Wind Park 2 project
      following changes to its Environmental Impact Assessment Report and Natura
      Impact Statement. The updated material includes additional site-specific
      data and peer-reviewed environmental research based on further project
      studies.
    </p>
    <p>
      The project is expected to deliver economic benefits of between €400
      million and €800 million and support up to 2,300 jobs. Further research
      and technical modelling are being used to assess potential environmental
      impacts, including coastline erosion and effects on seabird populations.
      Public observations are open from 3 June to 29 July.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Arklow Bank 2 illustrates the central challenge for Ireland’s offshore
      wind market: strong policy ambition is now meeting the practical realities
      of consenting, environmental evidence and public scrutiny. Ireland needs
      early projects like Arklow Bank 2 to progress if it is to build confidence
      in its emerging offshore wind regime.
    </p>
    <p>
      The fact that additional environmental work is being incorporated should
      not be read only as delay; it is also part of building a more robust
      consenting record. However, for investors, repeated information requests
      can create uncertainty around timelines. Ireland’s opportunity remains
      significant, but its competitive position will depend on whether planning
      authorities, grid bodies and developers can turn early-stage promise into
      repeatable consenting and delivery processes.
    </p>
    <h3>4. The Netherlands installs first turbine at Hollandse Kust West VI</h3>
    <p>
      The first turbine has been installed at the 760 MW Hollandse Kust West VI
      offshore wind farm in the Netherlands. The project, being developed around
      53 kilometres off the Dutch coast near IJmuiden, will comprise 52 Vestas
      V236-15.0 MW turbines.
    </p>
    <p>
      The installation campaign began from Eemshaven, with Van Oord’s Boreas
      installing the first turbine at the project site on 30 May. The project
      includes ecological design measures, including seven turbines fitted with
      one red-painted blade to test whether increased rotor visibility can
      reduce bird collision risk. Hollandse Kust West VI is expected to be
      operational by the end of 2026 and to supply around 3% of current Dutch
      electricity demand.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This project is strategically important because it shows how offshore wind
      is evolving from pure capacity deployment towards nature-inclusive design
      and environmental performance. The Netherlands is one of Europe’s most
      mature offshore wind markets, so innovation here can influence procurement
      and permitting expectations elsewhere.
    </p>
    <p>
      The red-blade trial may appear small, but it sits within a broader trend:
      governments and developers are under increasing pressure to show that
      offshore wind can scale while managing biodiversity risk. For future
      auctions, ecological performance may become part of competitive
      differentiation, especially in dense marine areas where shipping,
      fisheries, nature protection and grid corridors increasingly overlap.
    </p>
    <h3>
      5. Germany’s Windanker and Nordseecluster A advance construction readiness
    </h3>
    <p>
      Two German offshore wind projects reached important milestones this week.
      At Iberdrola’s 315 MW Windanker project in the Baltic Sea, Van Oord
      completed installation and burial of 21 inter-array cables with a combined
      length of 28 kilometres. The project will feature 21 Siemens Gamesa 15 MW
      turbines and is scheduled for full commissioning in 2027.
    </p>
    <p>
      Separately, DNV certified the third milestone for Nordseecluster A in the
      German North Sea, clearing the way for turbine installation.
      Nordseecluster A, developed by RWE and Norges Bank Investment Management,
      will comprise 44 Vestas V236-15.0 MW turbines and deliver 660 MW once
      fully commissioned in early 2027. Nordseecluster B is expected to add 900
      MW from 2029.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Germany’s offshore wind market is sending mixed but important signals. On
      one hand, policy and auction design questions continue to weigh on
      long-term investor confidence. On the other hand, projects already through
      FID are moving forward with visible construction progress.
    </p>
    <p>
      Windanker strengthens Iberdrola’s German Baltic portfolio, while
      Nordseecluster A reinforces RWE’s role as a core German North Sea player.
      The key commercial takeaway is that Germany still offers scale and
      industrial depth, but the market must maintain auction credibility, grid
      readiness and supply chain confidence if it wants to avoid future delays.
      Execution milestones like these are positive, but they do not remove the
      need for policy clarity.
    </p>
    <h3>
      6. JERA Nex BP in talks with German government over 4 GW Oceanbeat complex
    </h3>
    <p>
      JERA Nex BP is in talks with the German government and other stakeholders
      over the future of its 4 GW Oceanbeat offshore wind complex in the German
      North Sea. The complex includes Oceanbeat East and Oceanbeat West, two
      projects originally awarded to BP in Germany’s 2023 offshore wind auction
      and now being developed by JERA Nex BP.
    </p>
    <p>
      The projects are expected to provide around 4 GW of potential generating
      capacity from the beginning of the next decade. However, Germany’s
      offshore wind market has been under increasing pressure from grid
      connection delays, auction design concerns and deteriorating project
      economics. Germany’s offshore wind lobby has recently proposed legal
      reforms that would allow developers to voluntarily return unused offshore
      wind sites so they can be retendered and delays to the national offshore
      wind build-out can be limited.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Oceanbeat is highly significant because it goes directly to the question
      of whether Europe’s largest power market can maintain investor confidence
      in offshore wind under its current auction and grid framework. Germany has
      relied heavily on uncapped negative bidding in recent offshore wind
      tenders, but this model has become increasingly difficult as project
      costs, financing conditions and grid uncertainty have changed.
    </p>
    <p>
      If major developers such as JERA Nex BP need to renegotiate project
      conditions, the issue is not simply company-specific; it points to a
      broader structural problem in auction design. If projects are held by
      developers but no longer economically viable, Germany risks creating a
      “paper pipeline” that looks strong on capacity but weak on real delivery.
      A more flexible mechanism for site return or retendering may help preserve
      momentum, but it must be designed carefully to avoid moral hazard and
      protect credibility in future auctions.
    </p>
    <h3>7. US offshore wind faces fresh legal and contractual pressure</h3>
    <p>
      US offshore wind faced two major legal developments this week. Seven US
      states sued the federal administration and TotalEnergies over the
      cancellation of a major offshore wind lease off New York, challenging a
      deal that reimbursed the company and involved commitments to invest
      instead in fossil fuel projects. The states argue the decision undermines
      clean energy and energy security goals.Separately, a Massachusetts judge
      refused to lift an injunction requiring GE Vernova to continue work on the
      806 MW Vineyard Wind project. GE Vernova had sought to exit the project
      amid a payment dispute, while Vineyard Wind argued that the supplier’s
      role remained essential to bringing the project to full operational
      capacity.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The US market remains the most politically volatile major offshore wind
      market. The legal challenge over lease cancellation shows that state
      governments are prepared to push back against federal policy shifts where
      offshore wind is central to decarbonisation, power supply and job creation
      strategies.
    </p>
    <p>
      Meanwhile, the Vineyard Wind dispute shows that project delivery risk is
      no longer only about permitting and politics; it also includes OEM
      performance, warranty exposure, payment disputes and post-installation
      commissioning dependency. For international investors, the US still offers
      large demand potential, but risk pricing has changed. Offshore wind
      projects now require stronger legal structuring, contingency planning and
      a much more conservative view of policy continuity.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
